import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Input } from 'reactstrap';
//SimpleBar
import SimpleBar from "simplebar-react";

//import images
import { useTranslation } from 'react-i18next';
import { useRole } from 'components/Hooks/UserHooks';
import { ROUTES } from 'routes/allRoutes';

const SearchOptionPages = () => {
    const { t } = useTranslation();
    const { userPermissions } = useRole();
    const [value, setValue] = useState("");
    const onChangeData = (value: any) => {
        setValue(value);
    };

    const menuItems: any = [
        {
            label: t('media.List'),
            link: ROUTES.MEDIA,
            icon: '',
            isShow: true,
        },
        {
            label: t('media.Revenue'),
            link: ROUTES.MEDIA_REVENUE,
            icon: '',
            isShow: true,
        },
        {
            label: t('account.menu_title'),
            link: ROUTES.ACCOUNT,
            icon: '',
            isShow: true,
        },
        {
            label: t('articles_management.articles_statistics'),
            link: ROUTES.ARTICLES_MANAGEMENT.ARTICLE_STATISTICS,
            icon: '',
            isShow: true,
        },
        {
            label: t('articles_management.articles_list'),
            link: ROUTES.ARTICLES_MANAGEMENT.ARTICLE_LIST,
            icon: '',
            isShow: true,
        },
        {
            label: t('cms_statistics.statistics'),
            link: ROUTES.CMS_HUB_STATISTICS,
            icon: '',
            isShow: true,
        },
        {
            label: t('cms_media.media_management'),
            link: ROUTES.CMS_HUB_MEDIA_MANAGEMENT,
            icon: '',
            isShow: true,
        },
        {
            label: t('membership.membership_management'),
            link: ROUTES.CMS_HUB_MEMBERSHIP,
            icon: '',
            isShow: true,
        },
        {
            label: t('inquiry.menu_title'),
            link: ROUTES.INQUIRY_MANAGEMENT,
            icon: '',
            isShow: true,
        },
    ]

    useEffect(() => {
        var searchOptions: any = document.getElementById("search-close-options");
        var dropdown: any = document.getElementById("search-dropdown");
        var searchInput: any = document.getElementById("search-options");

        searchInput.addEventListener("focus", function () {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
                dropdown.classList.add("show");
                searchOptions.classList.remove("d-none");
            } else {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
            }
        });

        searchInput.addEventListener("keyup", function () {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
                dropdown.classList.add("show");
                searchOptions.classList.remove("d-none");
            } else {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
            }
        });

        searchOptions.addEventListener("click", function () {
            searchInput.value = "";
            dropdown.classList.remove("show");
            searchOptions.classList.add("d-none");
        });

        document.body.addEventListener("click", function (e: any) {
            if (e.target.getAttribute('id') !== "search-options") {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
            }
        });
    }, []);

    const checkIsIncludeText = (text: string, search: string) => {
        return String(text).toUpperCase().includes(String(search).toUpperCase());
    };

    return (
        <React.Fragment>
            <form className="app-search d-none d-sm-block">
                <div className="position-relative">
                    <Input type="text" className="form-control" placeholder={`${t('Button Search')}...`}
                        id="search-options"
                        autoComplete="off"
                        value={value}
                        onChange={e => {
                            onChangeData(e.target.value);
                        }} />
                    <span className="mdi mdi-magnify search-widget-icon"></span>
                    <span className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                        id="search-close-options"></span>
                </div>
                <div className="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                    <SimpleBar style={{ height: "320px" }}>

                        <div className="dropdown-header mt-2">
                            <h6 className="text-overflow text-muted mb-1 text-uppercase">{t('Pages')}</h6>
                        </div>

                        {menuItems?.map((item: any, index: number) => (
                            <Link key={index} to={item?.link} className={`dropdown-item notify-item ${(!!item?.isShow && checkIsIncludeText(item?.label || '', value || '')) ? '' : 'd-none'}`}>
                                {item?.icon}
                                <span className="">{item?.label}</span>
                            </Link>
                        ))}
                    </SimpleBar>
                </div>
            </form>
        </React.Fragment>
    );
};

export default SearchOptionPages;